import i18n from 'i18n'
import * as React from 'react'
import { IconButtonSeeker, useToaster } from 'ui-seeker/core'
import { useRemoveUsers } from '../../hooks'

export default function IconRemoveMasterUsers({idLineSelected}) {

    const { showToaster } = useToaster()
    const { removeUsers } = useRemoveUsers()

	const handleClick = () => {
        showToaster.confirm(`Are you sure to remove selected master users?`, {
            onSuccess: () => {

                const data = {
                    id_user: idLineSelected,
                    enabled: false,
                    master: true
                }

                removeUsers(data)
            },
            onCancel: () => {
                showToaster.error(i18n.t('common:savedFilters.cancelled'))
            }
        })
        
	}

	return <IconButtonSeeker icon="trash-alt" iconType="fontAwesome" title={i18n.t('common:actions.removeMasterUsers')} onClick={handleClick} />
}